import React from 'react';
import { HeaderFlexRow, HeadingTitle } from 'components/styled-components';
import colors from 'utils/colors';
import styled from 'styled-components';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';

export const AdminManagementHeader = props => (
  <>
    <HeaderFlexRow>
      <HeadingTitle>Admin Tools</HeadingTitle>
    </HeaderFlexRow>
    <NavWrapper>
      <QuestionNav>
        <QLink
          onClick={() => props.handleChangeActive(0)}
          className={props.activeTitle === 0 && 'activeTitle'}
        >
          System Configuration
        </QLink>
        {hasPermission(
          props.appUser.permissions,
          permissions.VIEW_DEPARTMENTS
        ) && (
          <QLink
            onClick={() => props.handleChangeActive(1)}
            className={props.activeTitle === 1 && 'activeTitle'}
          >
            Manage Departments
          </QLink>
        )}
        <QLink
          onClick={() => props.handleChangeActive(2)}
          className={props.activeTitle === 2 && 'activeTitle'}
        >
          Email Templates
        </QLink>
        <QLink
          onClick={() => props.handleChangeActive(3)}
          className={props.activeTitle === 3 && 'activeTitle'}
        >
          Audit Log
        </QLink>
        <QLink
          onClick={() => props.handleChangeActive(4)}
          className={props.activeTitle === 4 && 'activeTitle'}
        >
          Manage API Users
        </QLink>
      </QuestionNav>
    </NavWrapper>
  </>
);

const NavWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;

const QuestionNav = styled.div`
  text-transform: uppercase;
  padding-top: 1rem;
  overflow: auto;
`;
const QLink = styled.a`
  position: relative;
  display: inline-block;
  margin: 4px 1.5rem 4px 1rem;
  outline: none;
  color: ${colors.gray};
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 400;
  text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
  font-size: 0.9rem;
  padding: 0 0 20px;

  &::after {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 1px;
    background: ${colors.primary};
    content: '';
    opacity: 0;
    -webkit-transition: height 0.3s, opacity 0.3s, -webkit-transform 0.3s;
    -moz-transition: height 0.3s, opacity 0.3s, -moz-transform 0.3s;
    transition: height 0.3s, opacity 0.3s, transform 0.3s;
    -webkit-transform: translateY(-10px);
    -moz-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  &:hover {
    outline: none;
    text-decoration: none;
    color: ${colors.primary};
  }

  &:hover::after {
    height: 4px;
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    transform: translateY(0px);
  }

  &.activeTitle::after {
    height: 4px;
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    transform: translateY(0px);
  }
  &.activeTitle {
    color: ${colors.primary};
  }
`;
